module.exports = __webpack_public_path__ + "img/resource-tech-image-09.84b77185.jpg";